












import { defineComponent } from '@vue/composition-api';
import { BaseToastTypeEnums } from './BaseToastTemplateUse';

export default defineComponent({
  name: 'BaseToastTemplate',
  props: {
    type: {
      required: true,
      type: String,
      validator:
        (value) => [BaseToastTypeEnums.SUCCESS, BaseToastTypeEnums.INFO, BaseToastTypeEnums.DANGER]
          .indexOf(value) !== -1,
    },
    title: {
      required: true,
      type: String,
    },
    text: {
      required: false,
      type: String,
    },
  },
});
